import { MedicalLicenceNumber } from '@dreryk/medical-licence-number-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { MedicalLicenceNumberInput as MedicalLicenceNumberInputComponent } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../../translations';

export type MedicalLicenceNumberValue = { medicalLicenceNumber: MedicalLicenceNumber | null };
type MedicalLicenceNumberInputProps = Pick<FormContextValues<MedicalLicenceNumberValue>, 'register'>;

export const MedicalLicenceNumberInput = (props: MedicalLicenceNumberInputProps): JSX.Element => {
   const controller = props.register('medicalLicenceNumber', {
      required: true,
   });

   return (
      <MedicalLicenceNumberInputComponent
         label={personnelTranslationKeys.medicalLicenceNumberLabel}
         controller={controller}
         testId={'medicalLicenceNumber'}
      />
   );
};
